export default {
	recommendedLength: 25,
};
